import React, { useState } from "react";
import parse from "html-react-parser";
import Link from "@mui/material/Link";
import { Button } from "@mui/material";

import { DefaultProps } from "model/props";
import { Pages } from "appConfig";

import { getLanguageString as _ } from "misc/lang";

import css from "./footer.module.scss";

var sprintf = require("sprintf-js").sprintf;

const Footer: React.FC<DefaultProps> = (props) => {
  const { navigate, manageCookies, isSmallScreen } = props;

  const [expanded, setExpanded] = useState<boolean>(false);

  const copyright = (
    <span>
      {parse(sprintf(_("footer", "copyright"), "" + new Date().getFullYear()))}
    </span>
  );

  const legal = (
    <>
      <Link
        href={Pages.TERMS_OF_SERVICE.path}
        onClick={(event) => navigate(Pages.TERMS_OF_SERVICE, event)}
      >
        {isSmallScreen ? "Terms" : "Terms of Service"}
      </Link>
      <Link
        href={Pages.PRIVACY_POLICY.path}
        onClick={(event) => navigate(Pages.PRIVACY_POLICY, event)}
      >
        {isSmallScreen ? "Privacy" : "Privacy Policy"}
      </Link>
      <Link
        href={Pages.LEGAL_NOTICE.path}
        onClick={(event) => navigate(Pages.LEGAL_NOTICE, event)}
      >
        {_("footer", "legal_notice")}
      </Link>
      <Link href="#cookieconsent" onClick={manageCookies}>
        {_("footer", "cookie_consent")}
      </Link>
    </>
  );

  return (
    <div className={css.footer}>
      <div className={css.column}>
        <div className={css.tagline}>
          Simplify app downloads with <span>onelink.to</span> all app stores
        </div>

        {isSmallScreen && expanded && (
          <>
            <div className={css.contact}>{parse(_("footer", "contact"))}</div>
            <div className={css.legal}>{legal}</div>
          </>
        )}

        {isSmallScreen && (
          <div className={css.bottomrow}>
            {copyright}
            <span className={css.flexfill}></span>
            <Button
              className={css.showmore}
              variant="text"
              color="inherit"
              size="small"
              onClick={() => isSmallScreen && setExpanded(!expanded)}
            >
              {expanded ? "-show less-" : "-show more-"}
            </Button>
          </div>
        )}

        {!isSmallScreen && (
          <div className={css.legal}>
            {copyright}
            {legal}
          </div>
        )}
      </div>

      {!isSmallScreen && (
        <div className={css.column}>
          <div className={css.contact}>{parse(_("footer", "contact"))}</div>
          <div className={css.copyright}>
            {parse(sprintf(_("footer", "info"), "" + new Date().getFullYear()))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Footer;
